import React from "react";
import styles from "../../utils/gridStyles.js";
import dateFormat from 'dateformat';
import setHeaderRender from "../../../components/app/setHeaderRender";
import { Form, Button, Modal, Col, Row, Tab, Tabs, Alert, Accordion } from 'react-bootstrap';
import { CiGlobe } from "react-icons/ci";

const setColumns = ({ modalDetail, allowWrite, changeDelay, setLoading, updateSelectMultiRows, selectUnselectAllRows, handleAdvisorClick }) => {

    return [
        {
            id: "checkbox",
            visible: true,
            pinned: true,
            width: "54px",
            cellRenderer: ({ value, data, onChange, disabled }) => (<input type="checkbox" onChange={onChange} checked={value} disabled={disabled}
                onClick={() => { updateSelectMultiRows(data.code); }} />),
            headerCellRenderer: ({ checked, disabled, onChange }) => (<input type="checkbox" onChange={onChange} checked={checked} disabled={disabled}
                onClick={selectUnselectAllRows} />)
        },
        {
            id: "code",
            field: "code",
            label: "code",
            width: '100px',
            sortable: false,
            resizable: true,
            headerCellRenderer: ({ tableManager, column }) => (setHeaderRender({ 'nameHeader': 'code', changeDelay, tableManager, column }))
        },
        {
            id: "2",
            field: "email",
            label: "Email",
            sortable: false,
            resizable: true,
            headerCellRenderer: ({ tableManager, column }) => (setHeaderRender({ 'nameHeader': 'Email', changeDelay, tableManager, column }))
        },
        {
            id: "7",
            field: "segCveAgenteId",
            label: "segCveAgenteId",
            sortable: false,
            headerCellRenderer: ({ tableManager, column }) => (<><table><tbody>
                <tr><td>Clave Agente</td></tr>
                <tr><td><input id="segCveAgenteId" name="segCveAgenteId" type="text" style={{ height: 20 }} onChange={e => changeDelay(('*' + e.target.value + '*'), tableManager, column)} /></td></tr>
            </tbody></table></>)
        },
        {
            id: "8",
            field: "lastActionOn",
            label: "Última Acción",
            sortable: false,
            cellRenderer: ({
                tableManager,
                value,
                data,
                column,
                colIndex,
                rowIndex
            }) => (data.lastActionOn
                ? dateFormat(new Date(data.lastActionOn), "dd/mm/yyyy HH:MM:ss", true)
                : dateFormat(new Date(), "dd/mm/yyyy HH:MM:ss", true))
        },
        {
            id: "10",
            field: "createdAt",
            label: "Fecha de Creación",
            sortable: false,
            cellRenderer: ({
                tableManager,
                value,
                data,
                column,
                colIndex,
                rowIndex
            }) => (data.createdAt
                ? dateFormat(new Date(data.createdAt), "dd/mm/yyyy HH:MM:ss", true)
                : dateFormat(new Date(), "dd/mm/yyyy HH:MM:ss", true)),
            sort: ({ a, b, isAscending }) => {
                const toIso = s => { const [d, t] = s.split(" "); return d.split("/").reverse().join("") + t; };
                let aa = toIso(a),
                    bb = toIso(b);
                return aa < bb
                    ? isAscending
                        ? -1
                        : 1
                    : aa > bb
                        ? isAscending
                            ? 1
                            : -1
                        : 0;
            }
        },
        {
            id: "createdAtActive",
            field: "createdAtActive",
            label: "Fecha Activación",
            sortable: false,
            cellRenderer: ({ data }) => (data.createdAtActive
                ? dateFormat(new Date(data.createdAtActive), "dd/mm/yyyy HH:MM:ss")
                : "-")
        },
        {
            id: "createdAtInactive",
            field: "createdAtInactive",
            label: "Fecha Inactivación",
            sortable: false,
            cellRenderer: ({ data }) => (data.createdAtInactive
                ? dateFormat(new Date(data.createdAtInactive), "dd/mm/yyyy HH:MM:ss")
                : "-")
        },
        {
            id: "enabledStatus",
            field: "enabled",
            label: "Activar Asesor",
            sortable: false,
            cellRenderer: ({ data }) => (data.enabled
                ? <Button variant="success" size="sm" onClick={() => handleAdvisorClick(data)}>Activo</Button>
                : <Button variant="danger" size="sm" onClick={() => handleAdvisorClick(data)}>Inactivo</Button>)
        }
    ];
};

export default setColumns;